import React, { useState } from "react";
import axios from "axios";
import Sikh from "./sikh";
import * as API from "../Endpoints/Endpoints"

const SikhGame = () => {
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [showQuestions, setShowQuestions] = useState(false);
  const [randomQuestions, setRandomQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [scores, setScores] = useState({});
  const [reasons, setReasons] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingScore, setLoadingScore] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState("");
   const [selectedLeadData, setSelectedLeadData] = useState(null);
    const [showPopupIndex, setShowPopupIndex] = useState(null);
  

  const isScoringDone = Object.keys(scores).length === randomQuestions.length;

 const handleLeadHover = async (leadName, index) => {
  try {
    const response = await axios.get(API.GET_SIKH_API);
    const leadData = response.data.find(item => item.knownreligiouslead === leadName);
    if (leadData) {
      setSelectedLeadData(leadData);
      setShowPopupIndex(index);
    }
  } catch (error) {
    console.error("Error fetching lead details:", error);
  }
};

const handleLeadLeave = () => {
  setShowPopupIndex(null);
};

    const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  
  const handleStartGame = async () => {
    setLoading(true);  
    try {
      const response = await axios.get(API.GET_SIKH_API);
      const filteredData = response.data.filter(item => item.religion === "Guru Granth");
      const shuffled = shuffleArray([...filteredData]);
      const selectedQuestions = shuffled.slice(0, 3);
      setRandomQuestions(selectedQuestions);
      setIsGameStarted(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);  // stop loading
    }
  };  

  const handleVideoStop = () => {
    setShowQuestions(true);
  };

  const handleAnswerChange = (index, value) => {
    setAnswers(prev => ({ ...prev, [index]: value }));
  };

  const handleSubmitAnswers = async () => {
  setLoadingScore(true);
  const newScores = {};
  const newReasons = {};

  for (let i = 0; i < randomQuestions.length; i++) {
    const questionText = randomQuestions[i].question;
    const userAnswer = answers[i] || "";

    try {
      const response = await axios.post(API.RELIGION_OPENAI_API, {
        question: questionText,
        answer: userAnswer,
        religion: "Sikh", // 👈 add religion context
      });

      const responseText =
        response.data.choices?.[0]?.message?.content || "";

      // Extract score
      const scoreMatch = responseText.match(/Score:\s*(\d+)/i);
      newScores[i] = scoreMatch ? parseInt(scoreMatch[1]) : 0;

      // Extract reason
      const reasonMatch = responseText.match(/Reason:\s*([\s\S]*)/i);
      newReasons[i] = reasonMatch
        ? reasonMatch[1].trim()
        : "No reason provided.";
    } catch (error) {
      console.error(`Error scoring answer for Q${i + 1}:`, error);
      newScores[i] = "Error";
      newReasons[i] = "Error retrieving reason.";
    }
  }

  setScores(newScores);
  setReasons(newReasons);
  setLoadingScore(false);
};
  
  const handleSubmitPlayData = async () => {
    try {
      for (let i = 0; i < randomQuestions.length; i++) {
        const payload = {
          question: randomQuestions[i].question,
          answer: answers[i] || "",
          score: scores[i] !== undefined ? scores[i].toString() : "0",
          reason: reasons[i] || "No reason provided"
        }; 
        await axios.post(API.SAVE_SIKHDATA_API, payload);
      }
      setSubmissionStatus("Data submitted successfully! ✅");
  } catch (error) {
    console.error("Error saving data:", error);
    setSubmissionStatus("Failed to submit data. ❌");
  }
};

const handleRefreshGame = () => {
  window.location.reload();
};

  return (
    <div className="flex flex-col items-center justify-center p-10 min-h-screen bg-gradient-to-br from-blue-800 via-black to-blue-400">

                {!isGameStarted ? (
            loading ? (
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-700 font-semibold">Loading...</p>
              </div>
            ) : (
              <button
                onClick={handleStartGame}
                className="px-6 py-3 bg-gradient-to-r from-blue-800 to-yellow-400 text-white rounded-xl hover:scale-105 transition"
              >    Start Game
              </button>
            )
          ) : (
        <div className="flex w-full gap-2 backdrop-blur-md bg-white/5 p-6 rounded-2xl shadow-2xl">
          {/* Left: cross Video */}
          <div className="w-2/3">
            <Sikh onVideoStop={handleVideoStop} />

            <div className="mt-4"> <button
          onClick={handleRefreshGame}
          className="px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-lg shadow hover:scale-105 transition"
        >
          Refresh Game
        </button> </div>
          </div>

          {/* Right: Questions */}
          {showQuestions && (
            <div className="w-1/3 space-y-6">

              <div className="bg-gradient-to-r from-blue-800 to-yellow-400 text-white text-center p-3 rounded-lg animate-pulse font-semibold">
                  ⚠️ Please provide detailed responses for better scores!
                </div>

              {randomQuestions.map((question, index) => (
                <div key={index} className=" p-4 rounded-lg shadow text-white">
                 <div className="bg-gradient-to-br from-blue-800 to-yellow-400 p-5 rounded-xl shadow-lg text-white">
                    <h2 className="font-bold text-lg mb-2">Q{index + 1}: {question.question}</h2>
                   <div className="relative inline-block">
                <p
                  onMouseEnter={() => handleLeadHover(question.knownreligiouslead, index)}
                  onMouseLeave={handleLeadLeave}
                  className="text-yellow-400 font-medium text-sm mb-3 cursor-pointer underline"
                >
                  Agent: {question.knownreligiouslead}
                </p>

                {/* Popup */}
                {showPopupIndex === index && selectedLeadData && (
                  <div className="absolute z-10 left-0 mt-1 w-64 bg-white text-black rounded-lg shadow-lg p-4 border border-gray-300 text-sm">
                    <p><strong>Religion:</strong> {selectedLeadData.religion}</p>
                    <p><strong>Passion Dimension:</strong> {selectedLeadData.passiondimension}</p>
                    <p><strong>Description:</strong> {selectedLeadData.briefdescriptionoflead}</p>
                    <p><strong>SDG:</strong> {selectedLeadData.relatedSDG}</p>
                  </div>
                )}
              </div>
                    <textarea
                      className="w-full h-20 p-2 rounded-lg border-none text-black focus:ring-2 focus:ring-yellow-300"
                      placeholder="Write your answer..."
                      value={answers[index] || ""}
                      onChange={(e) => handleAnswerChange(index, e.target.value)}
                    />
                  </div>
                {scores[index] !== undefined && (
                  <div className="mt-2 text-sm">
                    <p><strong>Score:</strong> {scores[index]}/10</p>
                    <p className="mt-1"><strong>Reason:</strong> {reasons[index]}</p>
                  </div>
                )}
                </div>
              ))}

              {/* Submit Button */}
             {loadingScore ? (
            <div className="flex items-center space-x-3">
                <div className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                <p className="px-5 py-2 from-blue-800 to-yellow-400 text-white">Scoring...</p>
            </div>
            ) : (
            <div className="flex space-x-4">
                <button
                onClick={handleSubmitAnswers}
                className="px-6 py-3 bg-gradient-to-r from-blue-800 to-yellow-400 text-white rounded-xl shadow-lg hover:scale-105 transition"
                > 
                View Score
                </button>

                {Object.keys(scores).length === randomQuestions.length && (
             <>  <button
                    onClick={handleSubmitPlayData}
                    className="px-6 py-3 bg-gradient-to-r from-blue-800 to-yellow-400 text-white rounded-xl shadow-lg hover:scale-105 transition"
                >  
                    Submit Data
                </button>

                {submissionStatus && (
                <div className="mt-3 space-y-2">
                  <p className={`text-sm font-medium ${submissionStatus.includes("successfully") ? "text-white" : "text-red-400"}`}>
                    {submissionStatus}
                  </p>
                
                </div>
              )} 
              </> 
                )}
            </div>
            )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SikhGame;
